
































































































import Vue from 'vue';
import DateInput from "@/components/DateInput.vue";
import api from './services/ParamtererizedAccountReportApi';
import dayjs from "dayjs";
import PartnerSearch from "../../partner/views/PartnerSearch.vue";
import Partner, { partnerDefaultProps } from "../../partner/models/Partner";

export default Vue.extend({
    components: {
        DateInput,
        PartnerSearch
    },

    data: () => ({
        invFrom: '',
        invTo: '',
        askDate: '',
        selectedPrefixes: [ 'GENI','GARO','GENO','INTO','INTR','NOTO','PARO','RES','SERO','SHCO','CARO','VIRI','VIRO' ],
        prefixes: [ 'GENI','GARO','GENO','INTO','INTR','NOTO','PARO','RES','SERO','SHCO','CARO','VIRI','VIRO' ],
        maxDisplay: 4,
        dateType: 'inv_date',
        type: 1,
        title: '',
        isPrinting: false,
        partner: 0,
        askDateVisible: true,
        dateTypeVisible: true,
        partnerVisible: true,
    }),

    beforeMount() {
        this.type = Number(this.$route.params["type"]);

        if (this.type == 1){
            this.title = 'Előleg számlák - Végszámlákhoz rendeltek';
        } else if (this.type == 0) {
            this.title= 'Előleg számlák - Összes';
        } else if (this.type == 2) {
            this.title = 'Előleg számlák - Végszámla nélkül';
        } else {
            this.title = 'Előleg számlák - Sztornózott';
        }

        this.invFrom = dayjs(new Date()).format("YYYY-MM-DD");
        this.invTo = dayjs(new Date()).format("YYYY-MM-DD");
        this.askDate = dayjs(new Date()).format("YYYY-MM-DD");

        if (this.type == 3) {
            this.askDateVisible = false;
            this.dateTypeVisible = false;
            this.partnerVisible = true;
        } else {
            this.askDateVisible = true;
            this.dateTypeVisible = true;
            this.partnerVisible = true;
        }
    },

    methods: {
        async getReport() {
            this.isPrinting = true;
            try {
                if (this.type == 3) {
                    const report = await api.getNotoReportSt({
                        FromDate: this.invFrom,
                        ToDate: this.invTo,
                        Prefixes: this.selectedPrefixes.join(","),
                        Partner: this.partner,
                    });

                    const a = document.createElement("a");
                    a.href = "data:application/pdf;base64," + report;
                    a.download = "elolegSt_" + dayjs(new Date()).format("YYYYMMDD") + ".pdf";
                    a.click();
                } else {
                    const report = await api.getNotoReport({
                        FromDate: this.invFrom,
                        ToDate: this.invTo,
                        AskDate: this.askDateVisible ? this.askDate : null,
                        AskDateType: this.askDateVisible ? this.dateType: null,
                        Prefixes: this.selectedPrefixes.map(x => '"' + x + '"').join(","),
                        Type: this.type,
                        Partner: this.partner,
                    });
                    
                    const a = document.createElement("a");
                    a.href = "data:application/pdf;base64," + report;
                    a.download = "eloleg_" + dayjs(new Date()).format("YYYYMMDD") + ".pdf";
                    a.click();
                }

            } finally {
                this.isPrinting = false;
            }
        },

        partnerSelected(partner: Partner) {
            this.partner = partner.id;
        }
    }
})
